module.exports = __webpack_public_path__ + "img/login-ciudadelahospitalaria.7f5a7ccd.svg";